import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { HttpInterceptorFn } from '@angular/common/http';
import { SessionService } from "../../services/session.service";
import { OfflineService } from "../../services/wpa/offline.service";
import { environment } from '../../../environments/environment';


export const authInterceptor: HttpInterceptorFn = (req, next) => {
    console.log('Interceptor appelé pour:', req.url);

    const publicUrl = [environment.apiUrl + '/auth/login'];


    console.log('URL de la requête:', req.url);
    console.log('URL publiques:', publicUrl.includes(req.url) ? 'Incluse' : 'Non incluse');
    if(!publicUrl.includes(req.url)) {
        const sessionService = inject(SessionService);
        const token = sessionService.token;
        console.log('Token:', token ? 'Présent' : 'Absent');
        if (token) {
            // Un token « offline » (non signé) ne doit jamais partir vers le serveur :
            // il y provoque une erreur (alg=none rejeté). Si on est de nouveau en ligne,
            // on l'invalide et on force une ré-authentification pour obtenir un vrai JWT
            // (les délivrances en attente restent en local et seront synchro après login).
            if (sessionService.isOfflineToken(token)) {
                if (inject(OfflineService).isOnline) {
                    const router = inject(Router);
                    sessionService.token = null;
                    router.navigate(['/auth/login'], { queryParams: { returnUrl: router.url } });
                }
                // en ligne comme hors ligne : on n'attache pas ce token
                return next(req);
            }
            const cloned = req.clone({
                headers: req.headers.set('Authorization', `Bearer ${token}`)
            });
            console.log('Token ajouté');
            return next(cloned);
        }
    }

    console.log(' Pas de token');
    return next(req);
};